import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { Sidebar } from '@/components/layout/Sidebar'
import { Footer } from '@/components/layout/Footer'
import { HelpPanel } from '@/components/help/HelpPanel'
import { ToastContainer } from '@/components/ui/Toast'
import { DashboardTour } from '@/components/tour'
import { useValuationStore } from '@/store/valuationStore'
import { usePageTracking } from '@/hooks/usePageTracking'
import { cn } from '@/utils/cn'

export function AppLayout() {
  const { caseId, hydrated, hydrateFromIDB } = useValuationStore()
  const location = useLocation()
  usePageTracking()

  // Rehydrate store from IndexedDB once on mount
  useEffect(() => {
    if (!hydrated) {
      hydrateFromIDB().catch((e) => console.error('hydrateFromIDB failed', e))
    }
  }, [hydrated, hydrateFromIDB])

  const hideSidebar =
    location.pathname === '/dashboard' ||
    location.pathname.startsWith('/claim/')

  return (
    <div className="min-h-screen">
      {/* Header */}
      <Header caseId={caseId} />

      {/* Body: sidebar + content */}
      <div
        className={cn(
          'flex min-h-[calc(100vh-60px)]',
          'transition-[grid-template-columns] duration-[280ms] ease-[cubic-bezier(0.4,0,0.2,1)]'
        )}
      >
        {!hideSidebar && <Sidebar />}

        {/* Page content via router outlet — extra bottom padding on mobile for the bottom nav */}
        <div className="flex-1 min-w-0 flex flex-col pb-nav">
          <Outlet />
          <Footer />
        </div>
      </div>

      {/* Contextual help panel (slides in from right) */}
      <HelpPanel />

      {/* Toast notifications */}
      <ToastContainer />

      {/* First-time guided dashboard tour — mounted at layout level so it survives the
          Dashboard -> Form route transition between steps 6 and 7 */}
      <DashboardTour />
    </div>
  )
}
